<template>
    <v-app>
        <router-view v-if="['login-keycloak', 'admin-access', 'unauthorised'].includes($route.name)"></router-view>
        <div v-else-if="hasLoaded">
            <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp"
                       :clipped-right="$vuetify.breakpoint.lgAndUp"
                       color="secondary"
                       dark
                       app
                       fixed>
                <v-toolbar-title>
                    <span class="text-h6" style="line-height:2.5em;">{{ applicationTitle }}</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <beta-chip></beta-chip>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <help-menu></help-menu>
                    <user-menu></user-menu>
                </v-toolbar-items>
            </v-app-bar>
            <v-main>
                <v-container fluid>
                    <v-slide-y-transition mode="out-in">
                        <v-row>
                            <v-col class="mx-2">
                                <router-view></router-view>
                            </v-col>
                        </v-row>
                    </v-slide-y-transition>
                </v-container>
            </v-main>
        </div>
    </v-app>
</template>

<script>
    import Vue from 'vue';
    import { eventBus } from '@/main'
    import { PublicClientApplication } from '@azure/msal-browser';
    import is from 'is_js'
    import Keycloak from 'keycloak-js';

    import Toaster from 'v-toaster';
    import 'v-toaster/dist/v-toaster.css';
    Vue.use(Toaster, { timeout: 5000 });

    import VueMask from 'v-mask'
    Vue.use(VueMask);

    import VCurrencyField from 'v-currency-field'
    Vue.use(VCurrencyField, {
        locale: 'en-GB',
        decimalLength: 2,
        autoDecimalMode: true,
        min: null,
        max: null,
        defaultValue: 0,
        valueAsInteger: false,
        allowNegative: false
    });

    import globalMixin from '@/views/components/mixins/base/global.js'
    import xsrfMixin from '@/views/components/mixins/base/xsrf.js'
    import keycloakAuthMixin from '@/views/components/mixins/base/keycloakAuth.js'
    import appApiMixin from '@/views/components/mixins/appApi.js'

    import BetaChip from '@/views/components/toolbar/BetaChip'
    import UserMenu from '@/views/components/toolbar/UserMenu'
    import HelpMenu from '@/views/components/toolbar/HelpMenu'

    export default {
        components: {
            'beta-chip': BetaChip,
            'user-menu': UserMenu,
            'help-menu': HelpMenu,
        },
        mixins: [
            globalMixin,
            xsrfMixin,
            keycloakAuthMixin,
            appApiMixin,
        ],
        data() {
            return {
                loadingMessage: 'Loading...',
                hasLoaded: false,
                showDrawer: true,
                appTokenIntervalID: null,
            }
        },
        computed: {
            HasSignedIn() { return sessionStorage.hasSignedIn === 'true' || false; }
        },
        async mounted() {
            this.InitialiseErrorAndConsole();

            eventBus.$off('sign-in:keycloak:start').$on('sign-in:keycloak:start', () => {
                sessionStorage.hasSignedIn = true;
                this.SignIn();
            });
            eventBus.$off('check-sso:keycloak:success').$on('check-sso:keycloak:success', () => {
                this.SetKeycloakInstance(this.keycloakInstance);
                this.LoadAppToken();

                if (['login-keycloak'].includes(this.$route.name)) {
                    this.$router.push({ path: '/' }).catch(() => { });
                }
            });
            eventBus.$off('sign-out:keycloak:start').$on('sign-out:keycloak:start', () => {
                this.ClearLogin();
                this.SignOut();
            });
            eventBus.$off('app-api-auth-token-fetch:success').$on('app-api-auth-token-fetch:success', () => this.hasLoaded = true);

            await this.SetKeycloakURL();
            await this.SetKeycloakRealm();
            await this.SetKeycloakClientID();

            this.InitialiseKeycloakInstance();
            this.UpdateLoadedFlag();

            if (is.ie() || is.edge()) window.location.href = process.env.BASE_URL + 'Browser/Index';
            else if (this.HasSignedIn) this.CheckSSO();
            else {
                switch (sessionStorage.loginMethod) {
                    default: this.$router.push({ name: 'login-keycloak' }).catch(() => {}); break;
                }
            }
        },
        methods: {
            InitialiseKeycloakInstance() {
                let keycloakInstance = new Keycloak(this.keycloakConfig);
                this.SetKeycloakInstance(keycloakInstance);
            },
            LoadAppToken() {
                let keycloakID = this.keycloakInstance?.subject;
                let username = this.keycloakInstance?.idTokenParsed?.preferred_username;
                let displayName = this.keycloakInstance?.idTokenParsed?.given_name + ' ' + this.keycloakInstance?.idTokenParsed?.family_name;

                if (keycloakID != null && username != null && displayName != null) {
                    this.LoadAppAuthToken(keycloakID, username, displayName);
                    this.appTokenIntervalID = setInterval(() => this.ReacquireAppToken(this.KeycloakID, this.Username, this.DisplayName), 10000);
                }
            },
            InitialiseErrorAndConsole() {
                eventBus.$on('alert:success', response => this.$toaster.success(response.message));
                eventBus.$on('alert:error', error => {
                    try { this.$toaster.error(JSON.parse(error)?.Message); }
                    catch (ex) { this.$toaster.error(error); }
                });

                eventBus.$on('console:error', error => {
                    try { console.error(JSON.parse(error)?.Message); }
                    catch (ex) { console.error(error); }
                });
            },
            UpdateLoadedFlag() {
                this.hasLoaded = !!sessionStorage.appToken;
            },
            ClearLogin() {
                sessionStorage.removeItem('appToken');
                sessionStorage.loginMethod = 'accessToken';
                sessionStorage.hasSignedIn = false;
                this.hasLoaded = false;
            },
        },
    }
</script>